import React from 'react'
import { Checkbox, Spin, Tooltip } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

// Simple stateful toggle that lets an agent opt-in to having a portfolio manager field on new clients.
class PortfolioManager extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // start undefined so we can show a loader until the value arrives
            add_portfolio_manager: undefined,
            waiting: false
        }
    }

    componentDidMount() {
        // Initialize checkbox value once agent data is available on first render.
        const { agentInfo } = this.props
        if (agentInfo && agentInfo.add_portfolio_manager !== undefined) {
            this.setState({ add_portfolio_manager: agentInfo.add_portfolio_manager })
        }
    }

    componentDidUpdate(prevProps) {
        const prevValue = prevProps.agentInfo ? prevProps.agentInfo.add_portfolio_manager : undefined
        const nextValue = this.props.agentInfo ? this.props.agentInfo.add_portfolio_manager : undefined

        // Sync local state only when the incoming prop actually changes and is defined.
        if (nextValue !== undefined && nextValue !== prevValue) {
            this.setState({ add_portfolio_manager: nextValue })
        }
    }

    handleAddPortfolioManagerCheckbox = async (add_portfolio_manager: any) => {
        // Save the toggle to the backend while showing a small spinner to block double clicks.
        this.setState({ waiting: true }, async () => {
            await users
                .updateAddPortfolioManager({
                    agent_id: this.props.agentId,
                    add_portfolio_manager: add_portfolio_manager
                })
                .then(() => {
                    this.setState({ add_portfolio_manager: add_portfolio_manager })
                })
                .catch(err => {
                    if (err) {
                        // Backend failed; notify the user in Hebrew as per existing copy.
                        alertPopup({ type: 'error', title: 'שגיאה בעדכון מנהל תיק', body: '' })
                    }
                })
                .finally(() => this.setState({ waiting: false }))
        })
    }

    render() {
        const { add_portfolio_manager, waiting } = this.state
        const loadingValue = add_portfolio_manager === undefined

        return (
            <div style={{ display: 'flex' }}>
                <Tooltip title="סוכן המסומן בסימון זה יתווסף לו שדה של מנהל תיק בהקמת לקוח">
                    <span style={{ ...style.box, ...style.rightBox }}>
                        {waiting || loadingValue ? (
                            <Spin size="small" />
                        ) : (
                            <Checkbox
                                onChange={e => this.handleAddPortfolioManagerCheckbox(e.target.checked)}
                                checked={!!add_portfolio_manager}
                            />
                        )}
                    </span>
                </Tooltip>

                <span style={{ ...style.box, ...style.leftBox }}>
                    <span>{'הצגת מנהל תיק'}</span>
                </span>
            </div>
        )
    }
}

const style = {
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px', width: 'fit-content' }
}

export default PortfolioManager
